function Header() {
	return (
		<header>
			<h1>Word Game</h1>
		</header>
	);
}

export default Header;
